module.exports = __webpack_public_path__ + "static/media/nicecream.525b549d.svg";